import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { CollectionStar } from '#src/atoms/icons/CollectionStar.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelL } from '#src/atoms/typography/index.tsx';
import { getRarityColor } from '#src/lib/colors.ts';
import type { Color } from '#src/style/types.ts';

const Wrapper = styled(Horizontal)`
  display: inline-flex;
`;

type Props = {
  score: number;
  suffix?: string | null;
  color?: Color;
  rarity?: Nullable<Rarity>;
};

export const Score = ({ score, suffix, color, rarity }: Props) => {
  const starColor = rarity ? getRarityColor(rarity) : color;

  return (
    <Wrapper as="span" gap={0.5}>
      <CollectionStar color={starColor} size={2} />
      <LabelL bold color={color}>
        {score}
        {suffix}
      </LabelL>
    </Wrapper>
  );
};
